// 序列化参数，创建 URL 编码文本字符串。
export const serialize = (params, baseUrl = '') => {
  let query = ''
  Object.keys(params).forEach(entry => {
    let value = params[entry]

    if (value !== null && value !== undefined && value !== '') {
      // /[\u4e00-\u9fa5]/ encodeURIComponent(value) // 如果直接编码value，会导致英文逗号等也被编码
      query += `${!query ? '' : '&'}${entry}=${value}`
    }
  })

  return baseUrl + (/\?/.test(baseUrl) ? '&' : query ? '?' : '') + query
}

// URL 参数
export const getParams = (location) => {
  const { search } = location || window.location
  const params = search.replace(/^\?+/, '').split('&')
  let paramsObj = {}

  params.forEach(item => {
    const param = item.split('=')

    if (param[0] && param[1]) {
      paramsObj[param[0]] = param[1]
    }
  })

  return paramsObj
}

export const getFlatData = (data) => {
  const newData = []

  function formatData (data) {
    data.forEach(item => {
      newData.push(item)
      if (Array.isArray(item.subCategories)) {
        formatData(item.subCategories)
      }
    })
  }

  formatData(data || [])

  return newData
}

export const getPath = (list = [], id) => {
  const path = []
  const last = list.find(item => item.id === id)

  const getNext = (pid) => {
    const parent = list.find(item => item.id === pid)
    if (parent !== undefined) {
      path.unshift(parent)
      getNext(parent.pid)
    }
  }

  if (last !== undefined) {
    getNext(last.id)
  }

  return path
}

export const toFixedPrice = (num, bits = 2) => {
  const price = parseFloat(num)
  return !isNaN(price) && (typeof price) === 'number' && price > 0 ? (price < 0.01 ? '0.01' : price.toFixed(bits)) : (0).toFixed(bits)
}

export const getToken = () => {
  return localStorage.getItem('token') || ''
}

export const setToken = (token) => {
  localStorage.setItem('token', token || '')
}

export const mul = (arg1, arg2, n = 2, noFixed = false) => {
  // eslint-disable-next-line one-var, prefer-const
  let r1 = arg1.toString(), r2 = arg2.toString(), m = 0;
  try { m += r1.split('.')[1].length } catch (e) { m += 0 }
  try { m += r2.split('.')[1].length } catch (e) { m += 0 }
  return noFixed ? Number((Number(r1.replace('.', '')) * Number(r2.replace('.', '')) / Math.pow(10, m))) : Number((Number(r1.replace('.', '')) * Number(r2.replace('.', '')) / Math.pow(10, m)).toFixed(n))
}

/* eslint-disable */
export const base64Encode =(str) => {
  var c1, c2, c3;
  var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var i = 0, len = str.length, string = '';

  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i == len) {
      string += base64EncodeChars.charAt(c1 >> 2);
      string += base64EncodeChars.charAt((c1 & 0x3) << 4);
      string += "==";
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i == len) {
      string += base64EncodeChars.charAt(c1 >> 2);
      string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
      string += base64EncodeChars.charAt((c2 & 0xF) << 2);
      string += "=";
      break;
    }
    c3 = str.charCodeAt(i++);
    string += base64EncodeChars.charAt(c1 >> 2);
    string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
    string += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
    string += base64EncodeChars.charAt(c3 & 0x3F)
  }
  return string
}

export const stores = [
  {
    id: "825078",
    _pic: 's-825078.jpg',
    _phone: '0394-8683713',
    name: "周口俏业建材",
    image:
      "http://image.yos168.com/media/dmg/a0/88fd5566b565499d98a4cffb06b1d95a/i4/a774f15958c6469d94ca445d01f3cb3f.png",
    description:
      "水暖器材、建筑装饰材料、五金交电、钢材、室内装饰材料、日用百货、陶瓷、石材、塑料水管、电线电缆等",
  },
  {
    id: "815637",
    _pic: 's-815637.jpg',
    _phone: '027-83086666',
    name: "湖北福到供应链",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=566a9882fd4a4b9bb1397dd1a8daebac",
    description: "建筑材料，装饰材料，家居水暖，五金劳保，日用百货",
  },
  {
    id: "804871",
    _pic: 's-804871.jpg',
    _phone: '0728-6952053',
    name: "潜江蜻蜓聚创",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=8eda50d555aa40d69196da6502145551",
    description:
      "民用管道、市政管道、低压电器、电线电缆、消防设备、仪表仪器、手电工具、照明灯饰、厨卫配件、防水涂料",
  },

  {
    id: "873213",
    _pic: 's-873213.jpg',
    _phone: '0763-2224111',
    name: "英德顺泰建材",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=537ef360e8a042e2b2391d931cb10f85",
    description:
      "专业从事五金、管槽、线缆、灯具、电工类产品、智能家居等产品的公司；主要涉及批发零售、工程项目、装饰公司等领域。",
  },
  {
    id: "824943",
    _pic: 's-824943.jpg',
    _phone: '0779-3900901',
    name: "北海联购建材",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=f9dea3fad6ac4994a748b354957a78af",
    description: "水管电线,五金,照明电器,水暖卫浴",
  },
  {
    id: "801171",
    _pic: 's-801171.jpg',
    _phone: '0779-7297665',
    name: "北海领喜建材",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=fd01b7a0644d40d4a52ac9f84b7ed7fa",
    description: "电线，开关插座，室内灯具，厨卫配件",
  },
  {
    id: "881006",
    _pic: 's-881006.jpg',
    _phone: '0777-8580050',
    name: "北海世亚建材",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=b1588601549b4997b890d0fee35ee588",
    description:
      "管道，电线电缆，水暖卫浴，照明灯具，油漆化工，五金工具，劳保日杂，防水，钢材，机电，防水",
  },
  {
    id: "829189",
    _pic: 's-829189.jpg',
    _phone: '0775-2093664',
    name: "玉林领联五金建材",
    image:
      "http://image.yos168.com/media/dmg/a0/f3cb217163c3475490b7e45e2ab0aef0/i4/c5c551c2421742de9ffb77ea09b2824d.png",
    description: "给排水,市政管道,电线电器,五金配件,水暖卫浴,开关插座",
  },
  {
    id: "855559",
    _pic: 's-855559.jpg',
    _phone: '0774-5682771',
    name: "贺州亿玖建材",
    image:
      "http://image.yos168.com/media/dmg/a0/21f30166e3c64e41a3b86ebc2beca054/i4/3327cf61db7142f8bf78bbb06386b554.png",
    description: "给排水，机电设备，照明电器、电线电缆、水暖卫浴、油漆化工",
  },
  {
    id: "920626",
    _pic: 's-920626.jpg',
    _phone: '0770-6659888',
    name: "防城港港塑腾贸易",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=4ff52f222e9a4f3a93fe506244e6f89e",
    description:
      "给排水，电线电缆，电工用品，照明电器，水暖卫浴，劳保用品，五金工具，安防用品等",
  },
  {
    id: "807802",
    _pic: 's-807802.jpg',
    _phone: '0771-3923376',
    name: "广西达之隆建材",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=8ec423a5-eca2-4b4d-b2ff-bdea3a15d46e.jpg",
    description:
      "联塑民用管道 联塑精品家装管  五一管 桂兴管 （联塑开关插座 LED照 开关箱）德力西开关 网联电线 桂林国际电线 金羚排气扇 依来德防水 厨卫洁具",
  },
  {
    id: "810343",
    _pic: 's-810343.jpg',
    _phone: '0763-3666902',
    name: "清远常乐建材",
    image:
      "https://www.yos168.com/lots-web/lsys/v1/getTopPic?topPicture=47a64419-fb73-45f0-8447-19c31f871d35.jpg",
    description:
      "联塑系列（管道、市政、精品家装、照明、开关、水暖卫浴、净水器等)、新亚电缆、珠江电缆、佛山照明、德力西电气、机电设备、嘉宝莉防水、化工产品、劳保消防、五金日杂、四季沐歌太阳能、灭火器、安防、钢管等",
  },
];
